(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5563],{

/***/ 44511:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);




const IconDiscord = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", null, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M14.268 10.07c-.696 0-1.246.593-1.246 1.33 0 .74.562 1.332 1.246 1.332.695 0 1.245-.593 1.245-1.331s-.562-1.331-1.245-1.331zm-4.456 0c-.696 0-1.245.593-1.245 1.33 0 .74.561 1.332 1.245 1.332.696 0 1.245-.593 1.245-1.331.012-.738-.55-1.331-1.245-1.331z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M20.2 0H3.842C2.463 0 1.34 1.113 1.34 2.481V18.7c0 1.368 1.123 2.481 2.502 2.481h13.844l-.647-2.215 1.562 1.428 1.477 1.344L22.715 24V2.481A2.514 2.514 0 0020.2 0zm-4.712 15.673s-.44-.52-.805-.968c1.599-.448 2.21-1.428 2.21-1.428a7.01 7.01 0 01-1.405.714 8.806 8.806 0 01-1.77.52 8.622 8.622 0 01-3.162-.012 9.349 9.349 0 01-1.794-.52 7.17 7.17 0 01-.891-.412c-.037-.024-.073-.036-.11-.06-.024-.012-.037-.024-.049-.024-.22-.121-.342-.206-.342-.206s.586.956 2.137 1.416c-.367.46-.818.992-.818.992-2.698-.084-3.723-1.827-3.723-1.827 0-3.861 1.757-6.996 1.757-6.996 1.758-1.295 3.418-1.258 3.418-1.258l.123.145c-2.198.617-3.199 1.573-3.199 1.573s.269-.145.72-.339c1.307-.568 2.344-.714 2.771-.762.074-.012.135-.024.208-.024a10.417 10.417 0 012.466-.025c1.16.134 2.405.472 3.674 1.15 0 0-.964-.907-3.04-1.525l.172-.193s1.672-.037 3.418 1.258c0 0 1.758 3.135 1.758 6.996 0-.012-1.026 1.73-3.724 1.815z"
  }));
};

const ForwardRef = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(IconDiscord, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
  svgRef: ref
}, props)));
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ }),

/***/ 20570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);




const IconFacebook = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", null, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M24 12.073C24 5.405 18.628 0 12 0S0 5.405 0 12.073C0 18.1 4.388 23.094 10.125 24v-8.437H7.078v-3.49h3.047v-2.66c0-3.025 1.79-4.697 4.533-4.697 1.312 0 2.686.236 2.686.236v2.971H15.83c-1.49 0-1.955.931-1.955 1.886v2.264h3.328l-.532 3.49h-2.796V24C19.613 23.095 24 18.1 24 12.073z"
  }));
};

const ForwardRef = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(IconFacebook, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
  svgRef: ref
}, props)));
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ }),

/***/ 41749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);




const IconInstagram = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", null, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M11.995 2.162c3.205 0 3.581.014 4.848.071 1.171.053 1.805.248 2.228.415.562.219.962.476 1.381.895.42.419.681.819.896 1.38.162.425.361 1.058.414 2.23.057 1.266.071 1.642.071 4.847 0 3.205-.014 3.58-.071 4.848-.053 1.171-.248 1.804-.414 2.228a3.722 3.722 0 01-.896 1.381c-.419.42-.819.681-1.38.895-.424.162-1.058.362-2.23.415-1.266.057-1.642.071-4.847.071-3.205 0-3.58-.014-4.847-.071-1.172-.053-1.805-.248-2.229-.415a3.723 3.723 0 01-1.38-.895 3.664 3.664 0 01-.896-1.38c-.162-.425-.362-1.058-.414-2.23-.058-1.266-.072-1.642-.072-4.847 0-3.205.014-3.581.072-4.848.052-1.171.247-1.804.414-2.228.219-.562.476-.962.895-1.381a3.665 3.665 0 011.381-.895c.424-.162 1.057-.362 2.229-.415 1.266-.062 1.647-.071 4.847-.071zm0-2.162C8.738 0 8.33.014 7.048.071 5.77.13 4.9.333 4.138.63a5.847 5.847 0 00-2.124 1.385A5.95 5.95 0 00.63 4.138C.333 4.9.129 5.771.07 7.052.014 8.33 0 8.738 0 11.995c0 3.257.014 3.667.071 4.948.058 1.276.262 2.147.558 2.914.304.79.719 1.457 1.385 2.124a5.95 5.95 0 002.124 1.386c.762.295 1.633.5 2.914.557 1.281.057 1.686.071 4.948.071 3.262 0 3.667-.014 4.948-.071 1.276-.057 2.147-.262 2.914-.557a5.847 5.847 0 002.124-1.386 5.949 5.949 0 001.385-2.124c.296-.762.5-1.633.558-2.914.057-1.281.071-1.686.071-4.948 0-3.262-.014-3.666-.071-4.947-.058-1.277-.262-2.148-.558-2.915a5.846 5.846 0 00-1.385-2.123A5.95 5.95 0 0019.862.624c-.762-.295-1.633-.5-2.914-.557C15.662.014 15.252 0 11.995 0z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M11.995 5.838a6.163 6.163 0 10.002 12.326 6.163 6.163 0 00-.002-12.326zm0 10.157a4 4 0 110-7.999 4 4 0 010 8zM18.4 7.029a1.438 1.438 0 100-2.877 1.438 1.438 0 000 2.877z"
  }));
};

const ForwardRef = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(IconInstagram, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
  svgRef: ref
}, props)));
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ }),

/***/ 85822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);




const IconReddit = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", null, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M14.528 16.093c-.535.535-1.692.728-2.507.728-.814 0-1.971-.193-2.507-.728a.31.31 0 00-.45 0 .31.31 0 000 .45c.857.857 2.486.921 2.979.921.471 0 2.121-.064 2.978-.921a.31.31 0 000-.45c-.171-.107-.385-.107-.493 0zM10.5 13.264a1.244 1.244 0 10-2.487.002 1.244 1.244 0 002.487-.002z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M12 0C5.379 0 0 5.379 0 12s5.379 12 12 12 12-5.379 12-12c.021-6.621-5.357-12-12-12zm6.964 13.607c.022.171.043.343.043.536 0 2.7-3.129 4.886-7.007 4.886-3.879 0-7.007-2.208-7.007-4.908 0-.171.021-.364.043-.535A1.755 1.755 0 014.007 12c0-.964.793-1.757 1.757-1.757.472 0 .9.193 1.222.493 1.221-.879 2.893-1.436 4.757-1.479l.9-4.178a.312.312 0 01.128-.193.298.298 0 01.236-.043l2.914.621c.215-.407.622-.707 1.115-.707a1.244 1.244 0 010 2.486 1.25 1.25 0 01-1.243-1.2l-2.614-.557-.793 3.75c1.843.064 3.493.621 4.692 1.478.322-.3.75-.493 1.222-.493.964 0 1.757.793 1.757 1.758-.043.75-.471 1.35-1.093 1.628z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M14.764 12a1.244 1.244 0 10.002 2.487A1.244 1.244 0 0014.764 12z"
  }));
};

const ForwardRef = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(IconReddit, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
  svgRef: ref
}, props)));
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ }),

/***/ 73973:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);




const IconTikTok = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: svgRef
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", null, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M21.143 0H2.857A2.86 2.86 0 000 2.857v18.286A2.86 2.86 0 002.857 24h18.286A2.86 2.86 0 0024 21.143V2.857A2.86 2.86 0 0021.143 0zM18.86 10.47a4.28 4.28 0 01-3.977-1.916v6.593a4.872 4.872 0 11-4.873-4.873c.102 0 .202.01.302.016v2.4c-.1-.011-.199-.03-.302-.03a2.487 2.487 0 000 4.974c1.374 0 2.587-1.082 2.587-2.456l.024-11.196h2.297a4.279 4.279 0 003.944 3.82v2.668"
  }));
};

const ForwardRef = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(IconTikTok, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
  svgRef: ref
}, props)));
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ }),

/***/ 15598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);




const IconTwitch = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", null, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M5.99 0L1.7 4.286v15.428h5.147V24l4.29-4.286h3.431L22.29 12V0H5.99zm14.583 11.143l-3.431 3.428H13.71l-3.002 3v-3h-3.86V1.714h13.725v9.429z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M18 4.714h-1.716v5.143H18V4.714zm-4.719 0h-1.715v5.143h1.715V4.714z"
  }));
};

const ForwardRef = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(IconTwitch, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
  svgRef: ref
}, props)));
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ }),

/***/ 42579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);




const IconTwitter = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", null, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M12 0C5.37 0 0 5.37 0 12s5.37 12 12 12 12-5.37 12-12S18.63 0 12 0zm6.024 9.726c.006.126.006.246.006.372 0 3.822-2.91 8.232-8.232 8.232a8.177 8.177 0 01-4.434-1.302 5.816 5.816 0 004.284-1.194 2.889 2.889 0 01-2.7-2.01 2.884 2.884 0 001.308-.048 2.891 2.891 0 01-2.322-2.838v-.036c.39.216.834.348 1.308.36a2.895 2.895 0 01-.9-3.858 8.208 8.208 0 005.964 3.024 2.894 2.894 0 014.926-2.64 5.859 5.859 0 001.836-.702 2.892 2.892 0 01-1.272 1.602 5.928 5.928 0 001.662-.456 5.657 5.657 0 01-1.434 1.494z"
  }));
};

const ForwardRef = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(IconTwitter, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
  svgRef: ref
}, props)));
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ }),

/***/ 95649:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);




const IconYouTube = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", null, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M23.495 6.145a3.038 3.038 0 00-2.127-2.14C19.5 3.5 12 3.5 12 3.5s-7.5 0-9.382.505c-1.036.272-1.84 1.09-2.127 2.14C0 8.027 0 11.955 0 11.955s0 3.927.505 5.809a3.037 3.037 0 002.127 2.14C4.5 20.41 12 20.41 12 20.41s7.5 0 9.382-.505c1.036-.272 1.84-1.09 2.127-2.14.491-1.882.491-5.81.491-5.81s0-3.927-.505-5.809zm-13.95 9.382V8.382l6.273 3.572-6.273 3.573z"
  }));
};

const ForwardRef = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(IconYouTube, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
  svgRef: ref
}, props)));
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ }),

/***/ 24080:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/support",
      function () {
        return __webpack_require__(5644);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 74733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_ContentWrapper; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./tailwindcss-classnames.ts
var tailwindcss_classnames = __webpack_require__(46115);
;// CONCATENATED MODULE: ./components/ContentWrapper/styles.ts

var contentWrapper = (0,tailwindcss_classnames/* classnames */.d)("w-11/12", "lg:max-w-screen-lg", "xl:max-w-screen-xl", "2xl:max-w-screen-2xl", "mx-auto", "xl:px-20");
/* harmony default export */ var styles = ((/* unused pure expression or super */ null && (contentWrapper)));

;// CONCATENATED MODULE: ./components/ContentWrapper/ContentWrapper.tsx








var ContentWrapper = function(_param) {
    var children = _param.children, className = _param.className, id = _param.id, fullBleed = _param.fullBleed, style = _param.style, dataTestId = _param.dataTestId, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "className",
        "id",
        "fullBleed",
        "style",
        "dataTestId"
    ]);
    var composedClassName = (0,react.useMemo)(function() {
        return (0,clsx_m/* default */.Z)((0,_define_property/* default */.Z)({}, contentWrapper, !fullBleed), className);
    }, [
        className,
        fullBleed
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: composedClassName,
        "data-test-id": dataTestId,
        id: id,
        style: style
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var ContentWrapper_ContentWrapper = (/*#__PURE__*/(0,react.memo)(ContentWrapper));

;// CONCATENATED MODULE: ./components/ContentWrapper/index.ts

/* harmony default export */ var components_ContentWrapper = (ContentWrapper_ContentWrapper);


/***/ }),

/***/ 66915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ FAQS; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconChevronDown.js
var IconChevronDown = __webpack_require__(3359);
// EXTERNAL MODULE: ./components/HydrateMdx/index.ts + 4 modules
var HydrateMdx = __webpack_require__(35304);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./tailwindcss-classnames.ts
var tailwindcss_classnames = __webpack_require__(46115);
;// CONCATENATED MODULE: ./components/Accordion/styles.ts


var container = (0,tailwindcss_classnames/* classnames */.d)("grid", "gap-4", "grid-cols-1", "md:grid-cols-1");
var item = (0,tailwindcss_classnames/* classnames */.d)("border", "border-gray-300", "dark:border-nzxt-dark-grey-400", "p-4", "rounded-md", "w-full");
var styles_title = (0,tailwindcss_classnames/* classnames */.d)("text-nzxt-light-grey-800", "dark:text-white", "text-base", "sm:text-lg", "md:text-xl", "leading-6", "font-semibold");
var styles_content = (0,tailwindcss_classnames/* classnames */.d)("mt-2", "text-base", "text-nzxt-light-grey-700", "dark:text-nzxt-dark-grey-100");
var activeAction = (0,tailwindcss_classnames/* classnames */.d)("rotate-180");
var svg = function(isActive) {
    return (0,tailwindcss_classnames/* classnames */.d)((0,_define_property/* default */.Z)({}, activeAction, isActive), "w-6", "h-6", "stroke-current", "text-gray-900", "transition-transform", "duration-300", "transform", "pl-0.5");
};
var accordionButton = (0,tailwindcss_classnames/* classnames */.d)("text-left", "flex", "justify-between", "items-center", "w-full");

;// CONCATENATED MODULE: ./components/Accordion/Accordion.tsx






var AccordionItem = function(param) {
    var title = param.title, content = param.content, markdownContent = param.markdownContent, active = param.active, onToggle = param.onToggle;
    var _contentRef_current;
    var contentRef = (0,react.useRef)(null);
    var _useState = (0,_sliced_to_array/* default */.Z)((0,react.useState)(0), 2), contentHeight = _useState[0], setContentHeight = _useState[1];
    (0,react.useEffect)(function() {
        if (active && contentRef.current) {
            setContentHeight(contentRef.current.scrollHeight);
        } else {
            setContentHeight(0);
        }
    }, [
        active,
        (_contentRef_current = contentRef.current) === null || _contentRef_current === void 0 ? void 0 : _contentRef_current.scrollHeight
    ]);
    var dynamicStyles = {
        height: active ? "".concat(contentHeight, "px") : "0px",
        overflow: "hidden",
        transition: "height 200ms ease-in-out"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: item,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                type: "button",
                className: accordionButton,
                onClick: onToggle,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                        className: styles_title,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconChevronDown/* default */.Z, {
                            className: svg(active)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: contentRef,
                style: dynamicStyles,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                    className: "".concat(styles_content, " ").concat(markdownContent ? "prose dark:prose-invert" : ""),
                    children: markdownContent ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HydrateMdx/* default */.Z, {
                        mdx: markdownContent
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: content
                    })
                })
            })
        ]
    });
};
var Accordion = function(param) {
    var _param_single = param.single, single = _param_single === void 0 ? true : _param_single, items = param.items;
    var _useState = (0,_sliced_to_array/* default */.Z)((0,react.useState)(new Array(items.length).fill(false)), 2), activeStates = _useState[0], setActiveStates = _useState[1];
    var toggleAccordion = function(index) {
        setActiveStates(function(currentStates) {
            if (!single) {
                return currentStates.map(function(active, i) {
                    return i === index ? !active : active;
                });
            }
            return currentStates.map(function(active, i) {
                return i === index ? !active : false;
            });
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: container,
        children: items.map(function(item, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionItem, {
                title: item.title,
                content: item.content,
                markdownContent: item.markdownContent,
                active: activeStates[index],
                onToggle: function() {
                    return toggleAccordion(index);
                }
            }, item.id);
        })
    });
};
/* harmony default export */ var Accordion_Accordion = (/*#__PURE__*/(0,react.memo)(Accordion));

;// CONCATENATED MODULE: ./components/FAQSection/FAQS.tsx



var Faqs = function(param) {
    var faqQuestions = param.faqQuestions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion_Accordion, {
        items: faqQuestions.map(function(question) {
            return {
                id: question.id,
                title: question.question,
                content: question.answer,
                markdownContent: question.markdownContent
            };
        })
    });
};
/* harmony default export */ var FAQS = (/*#__PURE__*/(0,react.memo)(Faqs));


/***/ }),

/***/ 75547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ FAQSection_FAQSection; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/ContentWrapper/index.ts + 2 modules
var ContentWrapper = __webpack_require__(74733);
// EXTERNAL MODULE: ./components/SectionWrapper/index.ts + 2 modules
var SectionWrapper = __webpack_require__(44514);
// EXTERNAL MODULE: ./components/SectionHeading/index.ts + 3 modules
var SectionHeading = __webpack_require__(82677);
// EXTERNAL MODULE: ./components/FAQSection/FAQS.tsx + 2 modules
var FAQS = __webpack_require__(66915);
// EXTERNAL MODULE: ./tailwindcss-classnames.ts
var tailwindcss_classnames = __webpack_require__(46115);
;// CONCATENATED MODULE: ./components/FAQSection/styles.ts

var container = (0,tailwindcss_classnames/* classnames */.d)("mx-auto");
var title = (0,tailwindcss_classnames/* classnames */.d)("text-3xl", "font-extrabold", "text-gray-900", "text-center");
var questionsWrapper = (0,tailwindcss_classnames/* classnames */.d)("mt-12");
var questionsDl = (0,tailwindcss_classnames/* classnames */.d)("grid", "grid-cols-faq", "gap-8");
var questionsDt = (0,tailwindcss_classnames/* classnames */.d)("md:text-xl", "text-nzxt-light-grey-800", "dark:text-nzxt-dark-grey-200", "text-lg", "leading-6", "font-semibold");
var questionsDd = (0,tailwindcss_classnames/* classnames */.d)("mt-2", "text-base", "text-nzxt-light-grey-700", "dark:text-white");

;// CONCATENATED MODULE: ./components/FAQSection/FAQSection.tsx







var FAQSection = function(param) {
    var title = param.title, _param_titleSize = param.titleSize, titleSize = _param_titleSize === void 0 ? "large" : _param_titleSize, titleAlignment = param.titleAlignment, faqQuestions = param.faqQuestions, noWrapperSpacing = param.noWrapperSpacing;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWrapper/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionWrapper/* default */.Z, {
            noSpacing: noWrapperSpacing,
            "data-test-id": "faq-block",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: container,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "faq",
                        className: "scroll-mt-[12rem]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHeading/* default */.Z, {
                            textPosition: (titleAlignment !== null && titleAlignment !== void 0 ? titleAlignment : "center").toLowerCase(),
                            heading: title,
                            headingSize: titleSize
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: questionsWrapper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQS/* default */.Z, {
                            faqQuestions: faqQuestions
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var FAQSection_FAQSection = (/*#__PURE__*/(0,react.memo)(FAQSection));

;// CONCATENATED MODULE: ./components/FAQSection/index.ts



/***/ }),

/***/ 68368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Head; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/react-datocms/dist/esm/Seo/renderMetaTags.js
var renderMetaTags = __webpack_require__(12569);
// EXTERNAL MODULE: ./node_modules/@ekolabs/eko-gallery-react/dist/eko-gallery-react.esm.js
var eko_gallery_react_esm = __webpack_require__(25959);
// EXTERNAL MODULE: ./node_modules/@amplitude/analytics-browser/lib/esm/index.js + 55 modules
var esm = __webpack_require__(80901);
// EXTERNAL MODULE: ./constants/index.ts + 18 modules
var constants = __webpack_require__(28448);
;// CONCATENATED MODULE: ./components/Head/Head.tsx











var buildLanguageAlternates = function(baseUrl, canonical) {
    var alts = constants/* SUPPORTED_LOCALES.map */.RFD.map(function(locale) {
        return {
            hrefLang: locale,
            href: canonical.replace(baseUrl, "".concat(baseUrl, "/").concat(locale))
        };
    });
    alts.push({
        hrefLang: "x-default",
        href: canonical
    });
    return alts;
};
var proxyOgImages = function(cmsData) {
    // eslint-disable-next-line security/detect-non-literal-regexp
    var regex = new RegExp("".concat("https://www.datocms-assets.com", "/"), "g");
    var headData = cmsData === null || cmsData === void 0 ? void 0 : cmsData.map(function(tag) {
        if (tag.attributes && tag.attributes.name && tag.attributes.name === "twitter:image" || tag.attributes && tag.attributes.property && tag.attributes.property === "og:image") {
            // eslint-disable-next-line no-param-reassign
            tag.attributes.content = tag.attributes.content.replace(regex, "".concat("https://nzxt.com", "/assets/cms/"));
        }
        return tag;
    });
    return headData;
};
var HeadComponent = function(_param) {
    var cmsData = _param.cmsData, baseUrl = _param.baseUrl, canonical = _param.canonical, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "cmsData",
        "baseUrl",
        "canonical"
    ]);
    var _titleEl_props;
    var router = (0,next_router.useRouter)();
    var headData = null;
    try {
        headData = (0,renderMetaTags/* renderMetaTags */.y)(proxyOgImages(cmsData));
    } catch (e) {
        console.error(e);
    }
    var titleEl = headData === null || headData === void 0 ? void 0 : headData.find(function(h) {
        return h.key === "title";
    });
    var _titleEl_props_children;
    var titleText = (_titleEl_props_children = titleEl === null || titleEl === void 0 ? void 0 : (_titleEl_props = titleEl.props) === null || _titleEl_props === void 0 ? void 0 : _titleEl_props.children) !== null && _titleEl_props_children !== void 0 ? _titleEl_props_children : null;
    (0,react.useEffect)(function() {
        var timeout = null;
        var handleRouteChange = function(url) {
            var ampBlArr = [
                constants/* ROUTE_PRODUCT */.e_n,
                constants/* ROUTE_CART */.TWV,
                "".concat(constants/* ROUTE_BUILD */.fOR, "/").concat(constants/* ROUTE_BUILD_PC */.JrS)
            ];
            var isBlacklisted = ampBlArr.some(function(u) {
                return url.includes(u);
            });
            if (!isBlacklisted) {
                timeout = setTimeout(function() {
                    (0,esm/* track */.j)("Page View", {
                        page_url: window.location.href,
                        page_title: titleText,
                        page_path: url,
                        page_domain: window.location.hostname,
                        page_location: window.location.href
                    });
                }, 1);
            }
        };
        router.events.on("routeChangeComplete", handleRouteChange);
        return function() {
            router.events.off("routeChangeComplete", handleRouteChange);
            clearTimeout(timeout);
        };
    }, [
        router.events,
        titleText
    ]);
    // initial page view event for eko
    (0,react.useEffect)(function() {
        eko_gallery_react_esm/* ekoWebPixel.track */.AB.track("pixel.page_viewed");
    }, []);
    // notify route change and track page view event for eko
    (0,react.useEffect)(function() {
        var handleRouteChange = function() {
            eko_gallery_react_esm/* ekoWebPixel.onRouteChanged */.AB.onRouteChanged();
            eko_gallery_react_esm/* ekoWebPixel.track */.AB.track("pixel.page_viewed");
        };
        router.events.on("routeChangeComplete", handleRouteChange);
        return function() {
            router.events.off("routeChangeComplete", handleRouteChange);
        };
    }, [
        router.events
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, (0,_object_spread/* default */.Z)({
                canonical: canonical,
                languageAlternates: buildLanguageAlternates(baseUrl, canonical)
            }, rest)),
            cmsData && /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: (0,renderMetaTags/* renderMetaTags */.y)(proxyOgImages(cmsData))
            })
        ]
    });
};
/* harmony default export */ var Head = (/*#__PURE__*/(0,react.memo)(HeadComponent));

;// CONCATENATED MODULE: ./components/Head/index.ts



/***/ }),

/***/ 35304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ HydrateMdx_HydrateMdx; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-mdx-remote/dist/index.js + 2 modules
var dist = __webpack_require__(33659);
// EXTERNAL MODULE: ./tailwindcss-classnames.ts
var tailwindcss_classnames = __webpack_require__(46115);
;// CONCATENATED MODULE: ./components/HydrateMdx/Components/Table/styles.ts

// eslint-disable-next-line import/prefer-default-export
var wrapper = (0,tailwindcss_classnames/* classnames */.d)("overflow-x-auto");

;// CONCATENATED MODULE: ./components/HydrateMdx/Components/Table/Table.tsx
/* eslint-disable @typescript-eslint/no-explicit-any */ 



var Table = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("table", (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var Table_Table = (/*#__PURE__*/(0,react.memo)(Table));

;// CONCATENATED MODULE: ./components/HydrateMdx/Components/Table/index.ts


;// CONCATENATED MODULE: ./components/HydrateMdx/HydrateMdx.tsx






var HydrateMdx = function(param) {
    var mdx = param.mdx, _param_components = param.components, components = _param_components === void 0 ? {} : _param_components;
    var mdxComponents = (0,react.useMemo)(function() {
        var standardComponents = {
            table: Table_Table
        };
        return (0,_object_spread/* default */.Z)({}, standardComponents, components);
    }, [
        components
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* MDXRemote */.R, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, mdx), {
        components: mdxComponents
    }));
};
/* harmony default export */ var HydrateMdx_HydrateMdx = (/*#__PURE__*/(0,react.memo)(HydrateMdx));

;// CONCATENATED MODULE: ./components/HydrateMdx/index.ts



/***/ }),

/***/ 217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ IconSection_IconSection; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./framework/api/utils/maxify/index.ts + 5 modules
var maxify = __webpack_require__(15409);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./utils/hooks/index.ts + 17 modules
var hooks = __webpack_require__(8904);
// EXTERNAL MODULE: ./components/IconDynamic/index.ts + 1 modules
var IconDynamic = __webpack_require__(97390);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconHeart.js
var IconHeart = __webpack_require__(25956);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconTestedwithCare.js
var IconTestedwithCare = __webpack_require__(47070);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/Icon2YearWarranty.js
var Icon2YearWarranty = __webpack_require__(1683);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconExpertlyBuilt.js
var IconExpertlyBuilt = __webpack_require__(41061);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconStep1.js
var IconStep1 = __webpack_require__(51402);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconStep2.js
var IconStep2 = __webpack_require__(20062);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconStep3.js
var IconStep3 = __webpack_require__(96520);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconGameSync.js
var IconGameSync = __webpack_require__(81178);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconSmartScheduling.js
var IconSmartScheduling = __webpack_require__(8361);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconRBGLEDStrips.js
var IconRBGLEDStrips = __webpack_require__(58853);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconCompleteCustomization.js
var IconCompleteCustomization = __webpack_require__(46261);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconSideGlasscasepanel.js
var IconSideGlasscasepanel = __webpack_require__(74480);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconAerFanRGB.js
var IconAerFanRGB = __webpack_require__(25361);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconH1.js
var IconH1 = __webpack_require__(12405);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconKrakenZ.js
var IconKrakenZ = __webpack_require__(4575);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconKrakenzpumps.js
var IconKrakenzpumps = __webpack_require__(58655);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconKraken.js
var IconKraken = __webpack_require__(47651);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconRadiatorSupportLarge.js
var IconRadiatorSupportLarge = __webpack_require__(62025);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconRadiatorSupport.js
var IconRadiatorSupport = __webpack_require__(40774);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconLighting.js
var IconLighting = __webpack_require__(18491);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconSettings2.js
var IconSettings2 = __webpack_require__(73611);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconIntegratedRearIO.js
var IconIntegratedRearIO = __webpack_require__(89089);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconPerformance2.js
var IconPerformance2 = __webpack_require__(64931);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconRGBCableComb.js
var IconRGBCableComb = __webpack_require__(66087);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconKrakenM22.js
var IconKrakenM22 = __webpack_require__(95488);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconReinforcedExtendedTubing.js
var IconReinforcedExtendedTubing = __webpack_require__(51732);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconWifi.js
var IconWifi = __webpack_require__(77128);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconMidTower.js
var IconMidTower = __webpack_require__(38654);
// EXTERNAL MODULE: ./components/ButtonLink/index.ts + 2 modules
var ButtonLink = __webpack_require__(86496);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var src_define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./tailwindcss-classnames.ts
var tailwindcss_classnames = __webpack_require__(46115);
;// CONCATENATED MODULE: ./components/IconSection/styles.ts


var smallSizes = (0,tailwindcss_classnames/* classnames */.d)("w-12", "h-12", "lg:w-8", "lg:h-8");
var largeSizes = (0,tailwindcss_classnames/* classnames */.d)("w-12", "h-12");
var styles_buildSystem = function(isSmall) {
    var _obj;
    return (0,tailwindcss_classnames/* classnames */.d)((_obj = {}, (0,src_define_property/* default */.Z)(_obj, smallSizes, isSmall), (0,src_define_property/* default */.Z)(_obj, largeSizes, !isSmall), _obj), "text-nzxt-dark-grey-500", "fill-current", "mx-auto", "col-span-1");
};
var sectionBg = (0,tailwindcss_classnames/* classnames */.d)("bg-nzxt-light-grey-100", "lg:rounded-md", "py-8", "lg:py-12", "px-4", "w-full", "lg:max-w-screen-lg", "xl:max-w-screen-xl", "2xl:max-w-screen-2xl", "mx-auto", "lg:px-10", "xl:px-20", "mx-auto");
var iconSection = function(hasBg) {
    return (0,tailwindcss_classnames/* classnames */.d)("flex", "flex-col", "md:flex-row", "justify-center", "space-y-6", "md:space-y-0", "md:space-x-4", (0,src_define_property/* default */.Z)({}, sectionBg, hasBg));
};
var centerSmall = (0,tailwindcss_classnames/* classnames */.d)("items-center", "md:items-end");
var iconSectionItem = function(isSmall) {
    return (0,tailwindcss_classnames/* classnames */.d)((0,src_define_property/* default */.Z)({}, centerSmall, isSmall), "md:w-1/3", "px-2", "md:px-0", "md:pt-0", "w-full", "md:text-center", "md:flex", "md:flex-col", "items-center", "md:space-y-2", "grid", "grid-cols-4");
};
var smallText = (0,tailwindcss_classnames/* classnames */.d)("text-xs", "px-4");
var defultText = (0,tailwindcss_classnames/* classnames */.d)("text-sm", "md:text-base", "px-2");
var deafultHeaderText = (0,tailwindcss_classnames/* classnames */.d)("text-xs", "md:text-lg", "px-2");
var styles_text = function(isSmall) {
    var _obj;
    return (0,tailwindcss_classnames/* classnames */.d)("text-nzxt-dark-grey-500", (_obj = {}, (0,src_define_property/* default */.Z)(_obj, smallText, isSmall), (0,src_define_property/* default */.Z)(_obj, defultText, !isSmall), _obj));
};
var heading = function(isSmall) {
    var _obj;
    return (0,tailwindcss_classnames/* classnames */.d)("text-nzxt-dark-grey-800", "font-semibold", (_obj = {}, (0,src_define_property/* default */.Z)(_obj, smallText, isSmall), (0,src_define_property/* default */.Z)(_obj, deafultHeaderText, !isSmall), _obj));
};
var withBg = (0,tailwindcss_classnames/* classnames */.d)("bg-nzxt-light-grey-100");
var noBg = (0,tailwindcss_classnames/* classnames */.d)("bg-transparent");
var getBg = function(hasBg) {
    var _obj;
    return classnames((_obj = {}, _define_property(_obj, withBg, hasBg), _define_property(_obj, noBg, !hasBg), _obj));
};
var textContainer = (0,tailwindcss_classnames/* classnames */.d)("col-span-3", "md:col-span-1", "md:mx-auto");

;// CONCATENATED MODULE: ./components/IconSection/IconSection.tsx
/* eslint-disable jsx-a11y/anchor-is-valid */ 








// to do: icons need updating
var IconSection = function(param) {
    var data = param.data, isSmall = param.isSmall, hasBg = param.hasBg;
    var locale = (0,router.useRouter)().locale;
    var region = (0,maxify/* getRegion */.ur)(locale);
    var regionalIconData = (0,react.useMemo)(function() {
        return Array.isArray(data) ? data.filter(function(c) {
            var _c_availableRegions;
            return (_c_availableRegions = c.availableRegions) === null || _c_availableRegions === void 0 ? void 0 : _c_availableRegions.some(function(r) {
                return (r === null || r === void 0 ? void 0 : r.region) === region;
            });
        }) : null;
    }, [
        data,
        region
    ]);
    var iconData = (regionalIconData === null || regionalIconData === void 0 ? void 0 : regionalIconData.length) > 0 ? regionalIconData : data;
    var buildSystem = styles_buildSystem;
    var ICON_SECTION_MAP = {
        Heart: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconHeart/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        TestedwithCare: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconTestedwithCare/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        TwoYearWarranty: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon2YearWarranty/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        ExpertlyBuilt: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconExpertlyBuilt/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        Step1: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconStep1/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        Step2: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconStep2/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        Step3: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconStep3/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        GameSync: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconGameSync/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        SmartScheduling: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSmartScheduling/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        RBGLEDStrips: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconRBGLEDStrips/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        CompleteCustomization: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCompleteCustomization/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        SideGlasscasepanel: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSideGlasscasepanel/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        AerFanRGB: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconAerFanRGB/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        H1: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconH1/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        KrakenZ: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconKrakenZ/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        Krakenzpumps: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconKrakenzpumps/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        Kraken: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconKraken/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        RadiatorSupportLarge: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconRadiatorSupportLarge/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        RadiatorSupport: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconRadiatorSupport/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        Lighting: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconLighting/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        Settings2: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSettings2/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        RearIO: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconIntegratedRearIO/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        Performance2: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconPerformance2/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        RGBCableComb: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconRGBCableComb/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        KrakenM22: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconKrakenM22/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        Reinforced: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconReinforcedExtendedTubing/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        Wifi: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWifi/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        MidTower: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconMidTower/* default */.Z, {
            className: buildSystem(isSmall)
        })
    };
    var LEARN_LABEL = (0,hooks/* useTranslation */.$G)("learn_more");
    return Array.isArray(iconData) && (iconData === null || iconData === void 0 ? void 0 : iconData.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: iconSection(hasBg),
        children: iconData === null || iconData === void 0 ? void 0 : iconData.map(function(item) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: iconSectionItem(isSmall),
                "data-test-id": "icon-subblock",
                children: [
                    item.iconName ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconDynamic/* default */.Z, {
                        iconName: item.iconName,
                        className: buildSystem(isSmall)
                    }) : ICON_SECTION_MAP[item.iconComponent],
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: textContainer,
                        children: [
                            item.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: heading(isSmall),
                                "data-test-id": "icon-block-title",
                                children: item.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: styles_text(isSmall),
                                "data-test-id": "icon-block-text",
                                children: item.text
                            }),
                            item.link && /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* default */.Z, {
                                href: item.link,
                                children: LEARN_LABEL
                            })
                        ]
                    })
                ]
            }, item.text);
        })
    }) : null;
};
/* harmony default export */ var IconSection_IconSection = (/*#__PURE__*/(0,react.memo)(IconSection));

;// CONCATENATED MODULE: ./components/IconSection/index.ts



/***/ }),

/***/ 99772:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ LinkGroup_LinkGroup; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./components/ButtonLink/index.ts + 2 modules
var ButtonLink = __webpack_require__(86496);
// EXTERNAL MODULE: ./utils/get-cms-link-url.ts
var get_cms_link_url = __webpack_require__(91087);
// EXTERNAL MODULE: ./tailwindcss-classnames.ts
var tailwindcss_classnames = __webpack_require__(46115);
;// CONCATENATED MODULE: ./components/LinkGroup/styles.ts

var base = (0,tailwindcss_classnames/* classnames */.d)("flex", "flex-wrap", "gap-4", "md:gap-7", "max-w-max", "items-center");
var buttonContainer = {
    left: (0,tailwindcss_classnames/* classnames */.d)(base),
    center: (0,tailwindcss_classnames/* classnames */.d)(base, "justify-center")
};
var textSize = (0,tailwindcss_classnames/* classnames */.d)("md:text-lg");

;// CONCATENATED MODULE: ./components/LinkGroup/LinkGroup.tsx
/* eslint-disable no-underscore-dangle */ 






var LinkGroup = function(param) {
    var links = param.links, alignment = param.alignment, _param_isInverted = param.isInverted, isInverted = _param_isInverted === void 0 ? false : _param_isInverted, _param_lg = param.lg, lg = _param_lg === void 0 ? false : _param_lg, _param_abCfgRoute = param.abCfgRoute, abCfgRoute = _param_abCfgRoute === void 0 ? false : _param_abCfgRoute, setModalOpen = param.setModalOpen;
    var hasButtons = Array.isArray(links) && (links === null || links === void 0 ? void 0 : links.filter(function(butt) {
        return butt === null || butt === void 0 ? void 0 : butt.linkLabel;
    }));
    var composedClassNameButton = (0,react.useMemo)(function() {
        return (0,clsx_m/* default */.Z)(buttonContainer[alignment || "center"], (0,_define_property/* default */.Z)({}, textSize, lg));
    }, [
        alignment,
        lg
    ]);
    return hasButtons ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: composedClassNameButton,
        "data-test-id": "link-group-block",
        children: links === null || links === void 0 ? void 0 : links.map(function(item) {
            var _link_parentCategory, _item_linkType, _item_externalLinkRef, _item_externalLinkRef1;
            var link = Array.isArray(item === null || item === void 0 ? void 0 : item.internalLink) ? item === null || item === void 0 ? void 0 : item.internalLink[0] : item === null || item === void 0 ? void 0 : item.internalLink;
            var internalLink = (item === null || item === void 0 ? void 0 : item.internalLink) ? (0,get_cms_link_url/* default */.Z)({
                contentType: link._modelApiKey,
                pageType: link.pageType,
                slug: link.slug,
                parentSlug: link === null || link === void 0 ? void 0 : (_link_parentCategory = link.parentCategory) === null || _link_parentCategory === void 0 ? void 0 : _link_parentCategory.slug
            }) : null;
            var linkType = item === null || item === void 0 ? void 0 : (_item_linkType = item.linkType) === null || _item_linkType === void 0 ? void 0 : _item_linkType.toLowerCase();
            var handleClick = function(e) {
                e.preventDefault();
                setModalOpen(true);
            };
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* default */.Z, {
                onClick: abCfgRoute ? handleClick : undefined,
                asButton: item === null || item === void 0 ? void 0 : item.asButton,
                buttonStyle: linkType,
                href: internalLink || (item === null || item === void 0 ? void 0 : (_item_externalLinkRef = item.externalLinkRef) === null || _item_externalLinkRef === void 0 ? void 0 : _item_externalLinkRef.url),
                customMargin: true,
                target: (item === null || item === void 0 ? void 0 : item.newTab) ? "_blank" : undefined,
                rel: (item === null || item === void 0 ? void 0 : item.newTab) ? "noopener noreferrer" : undefined,
                dark: isInverted,
                internalLink: Boolean(internalLink),
                dataTestId: "".concat(item === null || item === void 0 ? void 0 : item.id, "-button"),
                "aria-label": "".concat(item === null || item === void 0 ? void 0 : item.linkLabel, " ").concat(internalLink ? "".concat("https://nzxt.com").concat(internalLink) : item === null || item === void 0 ? void 0 : (_item_externalLinkRef1 = item.externalLinkRef) === null || _item_externalLinkRef1 === void 0 ? void 0 : _item_externalLinkRef1.url),
                children: item === null || item === void 0 ? void 0 : item.linkLabel
            }, item === null || item === void 0 ? void 0 : item.id);
        })
    }) : null;
};
/* harmony default export */ var LinkGroup_LinkGroup = (/*#__PURE__*/(0,react.memo)(LinkGroup));

;// CONCATENATED MODULE: ./components/LinkGroup/index.ts



/***/ }),

/***/ 82677:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SectionHeading_SectionHeading; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./tailwindcss-classnames.ts
var tailwindcss_classnames = __webpack_require__(46115);
;// CONCATENATED MODULE: ./components/SectionHeading/styles.ts


var centerPos = (0,tailwindcss_classnames/* classnames */.d)("text-center", "mx-auto");
var wrapper = function(textPos) {
    return (0,tailwindcss_classnames/* classnames */.d)("space-y-2", "mb-6", "md:mb-8", "lg:mb-10", "w-11/12", "md:max-w-screen-sm", "lg:max-w-screen-lg", "xl:max-w-screen-xl", (0,_define_property/* default */.Z)({}, centerPos, textPos === "center"));
};
var styles_heading = function(textPos, headingSize) {
    return (0,tailwindcss_classnames/* classnames */.d)((0,_define_property/* default */.Z)({
        h3: headingSize === "large",
        h5: headingSize === "small",
        "hyphen-auto": true
    }, centerPos, textPos === "center"));
};
var darkColor = (0,tailwindcss_classnames/* classnames */.d)("text-nzxt-light-grey-700");
var defaultColor = (0,tailwindcss_classnames/* classnames */.d)("text-nzxt-light-grey-600");
var styles_subheading = function(textPos, darkenSubheading) {
    var _obj;
    return (0,tailwindcss_classnames/* classnames */.d)("max-w-ch-50", (_obj = {}, (0,_define_property/* default */.Z)(_obj, centerPos, textPos === "center"), (0,_define_property/* default */.Z)(_obj, darkColor, darkenSubheading), (0,_define_property/* default */.Z)(_obj, defaultColor, !darkenSubheading), _obj));
};
var styles_image = function(textPos) {
    return (0,tailwindcss_classnames/* classnames */.d)("h-5", "md:h-6", "w-auto", "block", "mb-3", "md:mb-4", (0,_define_property/* default */.Z)({}, centerPos, textPos === "center"));
};

;// CONCATENATED MODULE: ./components/SectionHeading/eyebrow.tsx



var Eyebrow = function(param) {
    var image = param.image, textPosition = param.textPosition;
    var nonResponsiveUrl = image.nonResponsiveUrl, alt = image.alt, height = image.height, width = image.width;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        className: styles_image(textPosition),
        src: image && nonResponsiveUrl,
        alt: image && alt,
        height: image && height,
        width: image && width,
        loading: "lazy",
        decoding: "async",
        "data-test-id": "section-eyebrow"
    });
};
/* harmony default export */ var SectionHeading_eyebrow = (/*#__PURE__*/(0,react.memo)(Eyebrow));

;// CONCATENATED MODULE: ./components/SectionHeading/SectionHeading.tsx




var SectionHeading = function(param) {
    var heading = param.heading, subheading = param.subheading, eyebrowLogo = param.eyebrowLogo, eyebrow = param.eyebrow, lang = param.lang, textPosition = param.textPosition, _param_darkenSubheading = param.darkenSubheading, darkenSubheading = _param_darkenSubheading === void 0 ? false : _param_darkenSubheading, _param_headingSize = param.headingSize, headingSize = _param_headingSize === void 0 ? "large" : _param_headingSize;
    var sanitizedTextPosition = (textPosition === null || textPosition === void 0 ? void 0 : textPosition.toLowerCase()) || "center";
    return heading || subheading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: wrapper(sanitizedTextPosition),
        "data-test-id": "section-heading-block",
        children: [
            eyebrowLogo && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHeading_eyebrow, {
                textPosition: sanitizedTextPosition,
                image: eyebrowLogo
            }),
            eyebrow && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: eyebrow
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                lang: lang,
                className: styles_heading(sanitizedTextPosition, headingSize),
                "data-test-id": "section-heading",
                children: heading
            }),
            subheading && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: styles_subheading(sanitizedTextPosition, darkenSubheading),
                "data-test-id": "section-subheading",
                children: subheading
            })
        ]
    }) : null;
};
/* harmony default export */ var SectionHeading_SectionHeading = (/*#__PURE__*/(0,react.memo)(SectionHeading));

;// CONCATENATED MODULE: ./components/SectionHeading/index.ts



/***/ }),

/***/ 44514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_SectionWrapper; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./tailwindcss-classnames.ts
var tailwindcss_classnames = __webpack_require__(46115);
;// CONCATENATED MODULE: ./components/SectionWrapper/styles.ts

var sectionWrapper = (0,tailwindcss_classnames/* classnames */.d)("py-6", "md:py-12", "xl:py-16");
// Top Spacing
var defaultTop = (0,tailwindcss_classnames/* classnames */.d)("pt-6", "md:pt-12", "xl:pt-16");
var smallTop = (0,tailwindcss_classnames/* classnames */.d)("pt-4", "md:pt-6", "xl:pt-8");
var noneTop = (0,tailwindcss_classnames/* classnames */.d)("pt-0", "md:pt-0", "xl:pt-0");
// Bottom Spacing
var defaultBottom = (0,tailwindcss_classnames/* classnames */.d)("pb-6", "md:pb-12", "xl:pb-16");
var smallBottom = (0,tailwindcss_classnames/* classnames */.d)("pb-4", "md:pb-6", "xl:pb-8");
var noneBottom = (0,tailwindcss_classnames/* classnames */.d)("pb-0", "md:pb-0", "xl:pb-0");
/* harmony default export */ var styles = ((/* unused pure expression or super */ null && (sectionWrapper)));

;// CONCATENATED MODULE: ./components/SectionWrapper/SectionWrapper.tsx
/* eslint-disable no-nested-ternary */ 






// TODO: variableSpacing is a stop gap to a real spacing solution
// based on how this is used by content
// discussion is required @dan @donny
var SectionWrapper = function(_param) {
    var children = _param.children, className = _param.className, id = _param.id, ref = _param.ref, style = _param.style, _param_noSpacing = _param.noSpacing, noSpacing = _param_noSpacing === void 0 ? false : _param_noSpacing, variableSpacing = _param.variableSpacing, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "className",
        "id",
        "ref",
        "style",
        "noSpacing",
        "variableSpacing"
    ]);
    var variableSpacingStrings = variableSpacing ? variableSpacing === null || variableSpacing === void 0 ? void 0 : variableSpacing.split("/") : [];
    var spacingValuesTop = {
        Default: defaultTop,
        Small: smallTop,
        None: noneTop
    };
    var spacingValuesBottom = {
        Default: defaultBottom,
        Small: smallBottom,
        None: noneBottom
    };
    var composedClassName = (0,react.useMemo)(function() {
        return !noSpacing ? (variableSpacingStrings === null || variableSpacingStrings === void 0 ? void 0 : variableSpacingStrings.length) === 2 ? (0,clsx_m/* default */.Z)(spacingValuesTop[variableSpacingStrings[0]], spacingValuesBottom[variableSpacingStrings[1]], className) : (0,clsx_m/* default */.Z)(sectionWrapper, className) : className ? (0,clsx_m/* default */.Z)(className) : null;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        className,
        noSpacing,
        variableSpacingStrings
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        ref: ref,
        className: composedClassName,
        id: id
    }, rest), {
        style: style,
        children: children
    }));
};
/* harmony default export */ var SectionWrapper_SectionWrapper = (/*#__PURE__*/(0,react.memo)(SectionWrapper));

;// CONCATENATED MODULE: ./components/SectionWrapper/index.ts

/* harmony default export */ var components_SectionWrapper = (SectionWrapper_SectionWrapper);


/***/ }),

/***/ 51944:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Testimonials_Testimonials; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/SectionWrapper/index.ts + 2 modules
var SectionWrapper = __webpack_require__(44514);
// EXTERNAL MODULE: ./components/ContentWrapper/index.ts + 2 modules
var ContentWrapper = __webpack_require__(74733);
// EXTERNAL MODULE: ./utils/hooks/index.ts + 17 modules
var hooks = __webpack_require__(8904);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/keen-slider/react.js
var keen_slider_react = __webpack_require__(82730);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconChevronLeft.js
var IconChevronLeft = __webpack_require__(916);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconChevronRight.js
var IconChevronRight = __webpack_require__(44572);
// EXTERNAL MODULE: ./components/Image/index.tsx + 1 modules
var Image = __webpack_require__(87439);
// EXTERNAL MODULE: ./node_modules/keen-slider/keen-slider.min.css
var keen_slider_min = __webpack_require__(41595);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./tailwindcss-classnames.ts
var tailwindcss_classnames = __webpack_require__(46115);
;// CONCATENATED MODULE: ./components/Testimonials/styles.ts


var innerWrapper = (0,tailwindcss_classnames/* classnames */.d)("relative");
var imageWrapper = (0,tailwindcss_classnames/* classnames */.d)("mx-auto", "flex", "justify-center", "items-center");
var blockquote = (0,tailwindcss_classnames/* classnames */.d)("mt-10");
var activeQuote = (0,tailwindcss_classnames/* classnames */.d)("opacity-100", "text-lg");
var inactiveQuote = (0,tailwindcss_classnames/* classnames */.d)("text-sm", "opacity-50", "lg:opacity-100");
var innerBlockquote = function(isActive) {
    var _obj;
    return (0,tailwindcss_classnames/* classnames */.d)("max-w-md", "mx-auto", "text-center", "leading-7", "md:leading-6", "font-medium", "px-4", "text-nzxt-light-grey-800", "transition-opacity", "duration-200", "ease-in-out", (_obj = {}, (0,_define_property/* default */.Z)(_obj, activeQuote, isActive), (0,_define_property/* default */.Z)(_obj, inactiveQuote, !isActive), _obj));
};
var testimonialFooterWrapper = (0,tailwindcss_classnames/* classnames */.d)("mt-8");
var innerTestimonialFooter = (0,tailwindcss_classnames/* classnames */.d)("md:flex", "md:items-center", "md:justify-center");
var authorImageWrapper = (0,tailwindcss_classnames/* classnames */.d)("md:flex-shrink-0");
var activeImage = (0,tailwindcss_classnames/* classnames */.d)("opacity-100");
var inactiveImage = (0,tailwindcss_classnames/* classnames */.d)("opacity-50", "lg:opacity-100");
var styles_authorImage = function(isActive) {
    var _obj;
    return (0,tailwindcss_classnames/* classnames */.d)(imageWrapper, "h-10", "w-10", "rounded-full", "transition-opacity", "duration-200", "ease-in-out", (_obj = {}, (0,_define_property/* default */.Z)(_obj, activeImage, isActive), (0,_define_property/* default */.Z)(_obj, inactiveImage, !isActive), _obj));
};
var activeAuthor = (0,tailwindcss_classnames/* classnames */.d)("text-sm", "opacity-100");
var inactiveAuthor = (0,tailwindcss_classnames/* classnames */.d)("text-xs", "opacity-50", "lg:opacity-100");
var styles_author = function(isActive) {
    var _obj;
    return (0,tailwindcss_classnames/* classnames */.d)("font-medium", "text-gray-900", "transition-opacity", "duration-200", "ease-in-out", (_obj = {}, (0,_define_property/* default */.Z)(_obj, activeAuthor, isActive), (0,_define_property/* default */.Z)(_obj, inactiveAuthor, !isActive), _obj));
};
var authorWrapper = (0,tailwindcss_classnames/* classnames */.d)("mt-3", "text-center", "md:mt-0", "md:ml-4", "md:flex", "md:items-center");
var authorName = (0,tailwindcss_classnames/* classnames */.d)("text-base", "font-medium", "text-nzxt-light-grey-800");
var arrow = (0,tailwindcss_classnames/* classnames */.d)("h-6", "w-6", "text-nzxt-light-grey-900", "stroke-current");
var sliderButton = (0,tailwindcss_classnames/* classnames */.d)("focus:outline-none", "absolute", "bg-white", "rounded-full", "flex", "items-center", "justify-center", "p-2");
// testimonials large screen
var testimonialWrapper = (0,tailwindcss_classnames/* classnames */.d)("flex", "space-x-4");
var wrapper = (0,tailwindcss_classnames/* classnames */.d)("overflow-hidden");

;// CONCATENATED MODULE: ./components/Testimonials/Testimonial.tsx





var Testimonial = function(param) {
    var author = param.author, quote = param.quote, logo = param.logo, authorImage = param.authorImage, index = param.index, isActive = param.isActive;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            overflow: "hidden",
            minHeight: "250px"
        },
        className: "keen-slider__slide number-slide".concat(index),
        "data-test-id": "testimonial-item",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: innerWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: imageWrapper,
                    children: logo && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        data: logo.responsiveImage,
                        width: logo.responsiveImage.width,
                        height: logo.responsiveImage.height
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("blockquote", {
                    className: blockquote,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: innerBlockquote(isActive),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "“",
                                    quote,
                                    "”"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: testimonialFooterWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: innerTestimonialFooter,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: authorImageWrapper,
                                        children: author && authorImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                            data: authorImage.responsiveImage,
                                            width: authorImage.responsiveImage.width,
                                            height: authorImage.responsiveImage.height,
                                            className: styles_authorImage(isActive)
                                        })
                                    }),
                                    author && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: authorWrapper,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: styles_author(isActive),
                                            children: author
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Testimonials_Testimonial = (/*#__PURE__*/(0,react.memo)(Testimonial));

// EXTERNAL MODULE: ./components/Testimonials/Testimonial.module.css
var Testimonial_module = __webpack_require__(4566);
var Testimonial_module_default = /*#__PURE__*/__webpack_require__.n(Testimonial_module);
;// CONCATENATED MODULE: ./components/Testimonials/TestimonialCarousel.tsx











// to do: clean up CSS styles once direction is confirmed
var getSliderPerView = function(isSm, isMed) {
    switch(true){
        case isSm:
            return 1;
        case isMed:
            return 1.55;
        case !isSm && !isMed:
            return 2.55;
        default:
            return 1;
    }
};
var TestimonialsCarousel = function(param) {
    var testimonialsData = param.testimonialsData;
    var _useState = (0,_sliced_to_array/* default */.Z)((0,react.useState)(0), 2), currentSlide = _useState[0], setCurrentSlide = _useState[1];
    var _useState1 = (0,_sliced_to_array/* default */.Z)((0,react.useState)(false), 2), loaded = _useState1[0], setLoaded = _useState1[1];
    var timer = (0,react.useRef)(null);
    var isSm = (0,hooks/* useMedia */.GS)("sm");
    var isMd = (0,hooks/* useMedia */.GS)("md");
    var size = (0,react.useMemo)(function() {
        return getSliderPerView(isSm, isMd);
    }, [
        isSm,
        isMd
    ]);
    var _useKeenSlider = (0,_sliced_to_array/* default */.Z)((0,keen_slider_react/* useKeenSlider */.E)({
        slides: {
            perView: size,
            origin: "center",
            spacing: 15
        },
        mode: "free-snap",
        loop: true,
        slideChanged: function(slide) {
            setCurrentSlide(slide.track.details.rel);
        },
        created: function() {
            setLoaded(true);
        }
    }), 2), ref = _useKeenSlider[0], instanceRef = _useKeenSlider[1];
    (0,react.useEffect)(function() {
        // eslint-disable-next-line
        timer.current = setInterval(function() {
            if (isSm && (instanceRef === null || instanceRef === void 0 ? void 0 : instanceRef.current)) {
                instanceRef === null || instanceRef === void 0 ? void 0 : instanceRef.current.next();
            }
        }, 3000);
        return function() {
            clearInterval(timer.current);
        };
    }, [
        instanceRef,
        isSm
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)("keen-slider", (Testimonial_module_default()).testimonialFade, wrapper),
        ref: ref,
        children: [
            testimonialsData.map(function(testi, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Testimonials_Testimonial, {
                    author: testi.author,
                    authorImage: testi.authorImage,
                    quote: testi.quote,
                    logo: testi.logo,
                    index: i,
                    isActive: i === currentSlide
                }, "".concat(testi.quote, "-").concat(i));
            }),
            !isSm && loaded && instanceRef.current && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        onClick: function(e) {
                            var _instanceRef_current;
                            return e.stopPropagation() || ((_instanceRef_current = instanceRef.current) === null || _instanceRef_current === void 0 ? void 0 : _instanceRef_current.prev());
                        },
                        type: "button",
                        style: {
                            top: "40%",
                            left: "0px",
                            zIndex: 2
                        },
                        className: sliderButton,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconChevronLeft/* default */.Z, {
                            className: arrow
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        style: {
                            top: "40%",
                            right: "0px",
                            zIndex: 2
                        },
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        onClick: function(e) {
                            var _instanceRef_current;
                            return e.stopPropagation() || ((_instanceRef_current = instanceRef.current) === null || _instanceRef_current === void 0 ? void 0 : _instanceRef_current.next());
                        },
                        className: sliderButton,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconChevronRight/* default */.Z, {
                            className: arrow
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var TestimonialCarousel = (/*#__PURE__*/(0,react.memo)(TestimonialsCarousel));

;// CONCATENATED MODULE: ./components/Testimonials/TestimonialLarge.tsx




var TestimonialLarge_TestimonialsCarousel = function(param) {
    var testimonialsData = param.testimonialsData, _param_isLarge = param.isLarge, isLarge = _param_isLarge === void 0 ? true : _param_isLarge;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: testimonialWrapper,
        children: testimonialsData.map(function(testi, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Testimonials_Testimonial, {
                author: testi.author,
                authorImage: testi.authorImage,
                quote: testi.quote,
                logo: testi.logo,
                noCarousel: isLarge
            }, "".concat(testi.quote, "-").concat(i));
        })
    });
};
/* harmony default export */ var TestimonialLarge = (/*#__PURE__*/(0,react.memo)(TestimonialLarge_TestimonialsCarousel));

;// CONCATENATED MODULE: ./components/Testimonials/Testimonials.tsx







var Testimonials = function(param) {
    var testimonialsData = param.testimonialsData, _param_noWrapperSpacing = param.noWrapperSpacing, noWrapperSpacing = _param_noWrapperSpacing === void 0 ? false : _param_noWrapperSpacing;
    var isSm = (0,hooks/* useMedia */.GS)("sm");
    var isMd = (0,hooks/* useMedia */.GS)("md");
    var slideMinHeight = isSm ? "350px" : "250px";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionWrapper/* default */.Z, {
        style: {
            minHeight: slideMinHeight,
            maxHeight: "350px",
            overflow: "hidden"
        },
        noSpacing: noWrapperSpacing,
        "data-test-id": "testimonial-block",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWrapper/* default */.Z, {
            children: isSm || isMd ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialCarousel, {
                testimonialsData: testimonialsData
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialLarge, {
                testimonialsData: testimonialsData,
                isLarge: true
            })
        })
    });
};
/* harmony default export */ var Testimonials_Testimonials = (/*#__PURE__*/(0,react.memo)(Testimonials));

;// CONCATENATED MODULE: ./components/Testimonials/index.ts



/***/ }),

/***/ 5644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ support; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/Page/Notice/index.ts + 2 modules
var Notice = __webpack_require__(99789);
// EXTERNAL MODULE: ./components/RiverItem/index.ts + 3 modules
var RiverItem = __webpack_require__(42348);
// EXTERNAL MODULE: ./components/HeroTall/index.tsx + 2 modules
var HeroTall = __webpack_require__(24115);
// EXTERNAL MODULE: ./components/SimpleCardGrid/index.ts + 3 modules
var SimpleCardGrid = __webpack_require__(9458);
// EXTERNAL MODULE: ./components/MarketingCards/MarketingCardSection.tsx + 2 modules
var MarketingCardSection = __webpack_require__(2351);
// EXTERNAL MODULE: ./components/Home/CrftFeature/index.ts + 2 modules
var CrftFeature = __webpack_require__(61669);
// EXTERNAL MODULE: ./components/Hero/index.tsx + 2 modules
var Hero = __webpack_require__(16782);
// EXTERNAL MODULE: ./components/IconNav/index.ts + 2 modules
var IconNav = __webpack_require__(97725);
// EXTERNAL MODULE: ./components/FAQSection/index.ts + 2 modules
var FAQSection = __webpack_require__(75547);
// EXTERNAL MODULE: ./components/Testimonials/index.ts + 5 modules
var Testimonials = __webpack_require__(51944);
// EXTERNAL MODULE: ./components/SectionWrapper/index.ts + 2 modules
var SectionWrapper = __webpack_require__(44514);
// EXTERNAL MODULE: ./components/ContentWrapper/index.ts + 2 modules
var ContentWrapper = __webpack_require__(74733);
// EXTERNAL MODULE: ./components/IconSection/index.ts + 2 modules
var IconSection = __webpack_require__(217);
// EXTERNAL MODULE: ./components/ButtonLink/index.ts + 2 modules
var ButtonLink = __webpack_require__(86496);
// EXTERNAL MODULE: ./constants/index.ts + 18 modules
var constants = __webpack_require__(28448);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./utils/parse-locale.ts
var parse_locale = __webpack_require__(14442);
// EXTERNAL MODULE: ./utils/wait-for-global.ts
var wait_for_global = __webpack_require__(21984);
// EXTERNAL MODULE: ./components/Button/index.ts + 3 modules
var Button = __webpack_require__(49072);
// EXTERNAL MODULE: ./framework/api/utils/maxify/index.ts + 5 modules
var maxify = __webpack_require__(15409);
// EXTERNAL MODULE: ./utils/hooks/index.ts + 17 modules
var hooks = __webpack_require__(8904);
// EXTERNAL MODULE: ./components/HydrateMdx/index.ts + 4 modules
var HydrateMdx = __webpack_require__(35304);
;// CONCATENATED MODULE: ./components/SupportPage/SupportSection/AddressItems/MarkdownField.tsx



var MarkdownField = function(param) {
    var markdown = param.markdown;
    return markdown ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HydrateMdx/* default */.Z, {
            mdx: markdown
        })
    }) : null;
};
/* harmony default export */ var AddressItems_MarkdownField = (/*#__PURE__*/(0,react.memo)(MarkdownField));

// EXTERNAL MODULE: ./tailwindcss-classnames.ts
var tailwindcss_classnames = __webpack_require__(46115);
;// CONCATENATED MODULE: ./components/SupportPage/SupportSection/styles.ts

var detailsHeading = (0,tailwindcss_classnames/* classnames */.d)("h4");
var headingLabel = (0,tailwindcss_classnames/* classnames */.d)("text-nzxt-light-grey-500", "text-xs", "pb-4");
var topAddressSection = (0,tailwindcss_classnames/* classnames */.d)("space-y-2");
var addressColumn = (0,tailwindcss_classnames/* classnames */.d)("p-4", "md:p-0", "text-sm");
var hoursSection = (0,tailwindcss_classnames/* classnames */.d)("pt-4", "md:pt-4");
var contactButton = (0,tailwindcss_classnames/* classnames */.d)("my-4", "max-w-xs", "ml-4", "md:ml-0", "w-full");

;// CONCATENATED MODULE: ./components/SupportPage/SupportSection/AddressItems/Hours.tsx





var Hours = function(param) {
    var hours = param.hours;
    var SUPPORT_LABEL = (0,hooks/* useTranslation */.$G)("label_customer_support_hours");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: hoursSection,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: headingLabel,
                children: SUPPORT_LABEL
            }),
            hours ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HydrateMdx/* default */.Z, {
                mdx: hours
            }) : null
        ]
    });
};
/* harmony default export */ var AddressItems_Hours = (/*#__PURE__*/(0,react.memo)(Hours));

;// CONCATENATED MODULE: ./components/SupportPage/SupportSection/AddressColumn.tsx






var AddressColumn = function(param) {
    var addressColumnData = param.addressColumnData;
    var HEADQUARTERS = (0,hooks/* useTranslation */.$G)("label_headquarters");
    return addressColumnData ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: addressColumn,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: headingLabel,
                children: HEADQUARTERS
            }),
            addressColumnData.directorFieldMd && /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressItems_MarkdownField, {
                markdown: addressColumnData.directorFieldMd
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: topAddressSection,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressItems_MarkdownField, {
                        markdown: addressColumnData.addressFieldMd
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressItems_MarkdownField, {
                        markdown: addressColumnData.phoneNumberFieldMd
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressItems_Hours, {
                        hours: addressColumnData.hoursFieldMd
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressItems_MarkdownField, {
                        markdown: addressColumnData.holidayScheduleMd
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressItems_MarkdownField, {
                        markdown: addressColumnData.notificationMd
                    })
                ]
            })
        ]
    }) : null;
};
/* harmony default export */ var SupportSection_AddressColumn = (/*#__PURE__*/(0,react.memo)(AddressColumn));

;// CONCATENATED MODULE: ./components/SupportPage/SupportSection/DetailsColumns.tsx
/* eslint-disable react/jsx-no-useless-fragment */ /* eslint-disable no-underscore-dangle */ 




var DetailsColumns = function(param) {
    var addressColumnData = param.addressColumnData;
    var locale = (0,router.useRouter)().locale;
    var region = (0,maxify/* getRegion */.ur)(locale);
    var regionalAddressColumn = (0,react.useMemo)(function() {
        return Array.isArray(addressColumnData) ? addressColumnData.find(function(c) {
            var _c_availableRegions;
            return (_c_availableRegions = c.availableRegions) === null || _c_availableRegions === void 0 ? void 0 : _c_availableRegions.some(function(r) {
                return r.region === region;
            });
        }) : null;
    }, [
        addressColumnData,
        region
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: addressColumnData.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(SupportSection_AddressColumn, {
            addressColumnData: regionalAddressColumn
        })
    });
};
/* harmony default export */ var SupportSection_DetailsColumns = (/*#__PURE__*/(0,react.memo)(DetailsColumns));

;// CONCATENATED MODULE: ./components/SupportPage/SupportSection/DetailsSection.tsx
/* eslint-disable no-underscore-dangle */ /* eslint-disable jsx-a11y/anchor-is-valid */ 











var DetailsSection = function(param) {
    var markdownFields = param.markdownFields, heading = param.heading;
    var _useRouter = (0,router.useRouter)(), locale = _useRouter.locale, defaultLocale = _useRouter.defaultLocale;
    var parsedLocale = (0,parse_locale/* default */.Z)(defaultLocale, locale);
    var langForZendesk = parsedLocale[0] === "en" ? "en-us" : parsedLocale[0];
    var _useState = (0,_sliced_to_array/* default */.Z)((0,react.useState)(false), 2), openChat = _useState[0], setOpenChat = _useState[1];
    (0,react.useEffect)(function() {
        if (!openChat && "object" !== "undefined") {
            (0,wait_for_global/* default */.Z)("zE", function() {
                setOpenChat(true);
            });
        }
    }, [
        openChat
    ]);
    var onClick = (0,react.useCallback)(function() {
        if (openChat) {
            window.zE("messenger", "open");
        }
    }, [
        openChat
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionWrapper/* default */.Z, {
        "data-test-id": "details-section-block",
        noSpacing: true,
        children: [
            typeof heading === "string" && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: detailsHeading,
                "data-test-id": "details-section-heading",
                children: heading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-8",
                children: [
                    openChat && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        buttonStyle: "primary",
                        type: "button",
                        onClick: onClick,
                        customMargin: true,
                        className: contactButton,
                        children: "Chat with Us"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* default */.Z, {
                        asButton: true,
                        buttonStyle: "secondary",
                        href: constants/* ZENDESK_TICKET_URL.replace */.OaI.replace("en-us", langForZendesk),
                        target: "_blank",
                        className: contactButton,
                        customMargin: true,
                        children: "Email Us"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SupportSection_DetailsColumns, {
                addressColumnData: markdownFields
            })
        ]
    });
};
/* harmony default export */ var SupportSection_DetailsSection = (/*#__PURE__*/(0,react.memo)(DetailsSection));

;// CONCATENATED MODULE: ./components/SupportPage/SupportSection/index.ts


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./components/Input/index.ts + 2 modules
var Input = __webpack_require__(41781);
;// CONCATENATED MODULE: ./components/SupportPage/SearchForm/styles.ts

var heading = (0,tailwindcss_classnames/* classnames */.d)("h4", "mb-8");
var formWrapper = (0,tailwindcss_classnames/* classnames */.d)("flex", "gap-x-4");
var buttonWrapper = (0,tailwindcss_classnames/* classnames */.d)("flex", "justify-center", "mt-6");
var styles_contactButton = (0,tailwindcss_classnames/* classnames */.d)("w-auto");

;// CONCATENATED MODULE: ./components/SupportPage/SearchForm/SearchForm.tsx















var SearchForm = function() {
    var _useRouter = (0,router.useRouter)(), locale = _useRouter.locale, defaultLocale = _useRouter.defaultLocale;
    var parsedLocale = (0,parse_locale/* default */.Z)(defaultLocale, locale);
    var langForZendesk = parsedLocale[0] === "en" ? "en-us" : parsedLocale[0];
    var _useForm = (0,index_esm/* useForm */.cI)(), register = _useForm.register, handleSubmit = _useForm.handleSubmit, formState = _useForm.formState;
    var errors = formState.errors;
    var _useState = (0,_sliced_to_array/* default */.Z)((0,react.useState)(false), 2), loading = _useState[0], setLoading = _useState[1];
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                try {
                    setLoading(true);
                    window.location.href = "".concat(constants/* ZENDESK_ARTICLES_URL.replace */.pcJ.replace("en-us", langForZendesk), "/search?utf8=✓&query=").concat(data.query);
                    setLoading(false);
                } catch (err) {
                    setLoading(false);
                }
                return [
                    2
                ];
            });
        });
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: heading,
                children: (0,hooks/* useTranslation */.$G)("search_support_articles")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                className: formWrapper,
                onSubmit: handleSubmit(onSubmit),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        id: "query",
                        type: "text",
                        inputLabel: (0,hooks/* useTranslation */.$G)("label_search_for_help_articles"),
                        srOnlyLabel: true,
                        labelFor: "query"
                    }, register("query", {
                        required: true
                    })), {
                        requiredError: errors.query && errors.query.type === "required",
                        classes: {
                            inputClass: "!flex-auto !min-w-0 !w-auto !flex w-full !mt-0",
                            labelClass: "!flex-auto !min-w-0 !w-auto !flex"
                        }
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        type: "submit",
                        buttonStyle: "secondary",
                        className: styles_contactButton,
                        disabled: loading,
                        children: "Search"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var SearchForm_SearchForm = (SearchForm);

;// CONCATENATED MODULE: ./components/SupportPage/SearchForm/index.ts


;// CONCATENATED MODULE: ./components/SupportPage/SupportPage.tsx
/* eslint-disable no-param-reassign */ /* eslint-disable no-underscore-dangle */ 




















var SupportPage = function(param) {
    var page = param.page;
    var supportContent = page.content.find(function(s) {
        return s._modelApiKey === "support_section";
    });
    var topContent = page.content.filter(function(s) {
        return s._modelApiKey === "hero_primary" || s._modelApiKey === "page_notice_collection";
    });
    var restOfContent = page.content.filter(function(s) {
        return s._modelApiKey !== "hero_primary" && s._modelApiKey !== "support_section" && s._modelApiKey !== "markdown_content";
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            topContent && topContent.map(function(s) {
                return s.id && /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                    children: function() {
                        switch(s._modelApiKey){
                            case "page_notice_collection":
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWrapper/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "bg-white",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Notice/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, s), {
                                            pageNotice: s.pageNotice
                                        }))
                                    })
                                });
                            case "hero_primary":
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero/* default */.Z, (0,_object_spread/* default */.Z)({}, s));
                            default:
                                return null;
                        }
                    }()
                }, s.id);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWrapper/* default */.Z, {
                className: "mb-24",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid grid-cols-1 lg:grid-cols-12 gap-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-span-4 lg:col-span-8 lg:order-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionWrapper/* default */.Z, {
                                noSpacing: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchForm_SearchForm, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex justify-center mt-6",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* default */.Z, {
                                            asButton: true,
                                            buttonStyle: "secondary",
                                            href: constants/* ZENDESK_ARTICLES_URL */.pcJ,
                                            customMargin: true,
                                            internalLink: true,
                                            className: "!w-auto !min-w-0 !justify-center inline-flex items-center",
                                            children: "View all support articles"
                                        })
                                    }),
                                    restOfContent.map(function(s, i) {
                                        return s.id && /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                            children: function() {
                                                switch(s._modelApiKey){
                                                    case "river":
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RiverItem/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, s), {
                                                            isEven: i % 2 === 0
                                                        }));
                                                    case "hero_tall":
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroTall/* default */.Z, (0,_object_spread/* default */.Z)({
                                                            noContentWrapper: true
                                                        }, s));
                                                    case "crft_hero":
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CrftFeature/* default */.Z, (0,_object_spread/* default */.Z)({}, s));
                                                    case "marketing_three_card_collection":
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionWrapper/* default */.Z, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MarketingCardSection/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                                threeCardGrid: true
                                                            }, s), {
                                                                marketingCardData: s.marketingCard
                                                            }))
                                                        });
                                                    case "simple_card_grid":
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleCardGrid/* default */.ZP, (0,_object_spread/* default */.Z)({
                                                            simpleCardGridData: s.simpleCards,
                                                            heading: s.sectionHeading,
                                                            noContentWrapper: true
                                                        }, s));
                                                    case "icon_nav_collection":
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconNav/* default */.Z, (0,_object_spread/* default */.Z)({}, s));
                                                    case "faq_section":
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQSection/* default */.Z, (0,_object_spread/* default */.Z)({}, s));
                                                    case "testimonal_collection":
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Testimonials/* default */.Z, {
                                                            testimonialsData: s.testimonials
                                                        });
                                                    case "marketing_card2_x2_collection":
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionWrapper/* default */.Z, {
                                                            "data-test-id": "marketing-card2-x2-block",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MarketingCardSection/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, s), {
                                                                marketingCardData: s.marketingCard
                                                            }))
                                                        });
                                                    case "icon_block":
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSection/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, s), {
                                                            hasBg: true,
                                                            data: s.iconBlock
                                                        }));
                                                    default:
                                                        return null;
                                                }
                                            }()
                                        }, s.id);
                                    })
                                ]
                            })
                        }),
                        supportContent && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-span-4 lg:order-1",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SupportSection_DetailsSection, {
                                heading: supportContent.sectionHeading,
                                markdownFields: supportContent.markdownFields
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var SupportPage_SupportPage = (/*#__PURE__*/(0,react.memo)(SupportPage));

;// CONCATENATED MODULE: ./components/SupportPage/index.ts


// EXTERNAL MODULE: ./components/Head/index.ts + 1 modules
var Head = __webpack_require__(68368);
// EXTERNAL MODULE: ./components/Layout/index.ts + 25 modules
var Layout = __webpack_require__(16119);
;// CONCATENATED MODULE: ./pages/support.tsx





var Support = function(param) {
    var baseUrl = param.baseUrl, page = param.page;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* default */.Z, {
                baseUrl: baseUrl,
                canonical: "".concat(baseUrl, "/").concat(constants/* ROUTE_SUPPORT */.QZb),
                cmsData: page.seo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SupportPage_SupportPage, {
                page: page
            })
        ]
    });
};
Support.Layout = Layout/* default */.Z;
var __N_SSG = true;
/* harmony default export */ var support = (Support);


/***/ }),

/***/ 4566:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"testimonialFade":"Testimonial_testimonialFade__guqk3"};

/***/ }),

/***/ 32746:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Allow jsx-runtime to be successfully imported from either React 17 or React 18.
 *
 * Inspired by the approach here: https://github.com/contentlayerdev/contentlayer/blob/main/packages/next-contentlayer/src/hooks/jsx-runtime.cjs
 */
const jsxRuntime = __webpack_require__(85893)

module.exports.c = jsxRuntime


/***/ }),

/***/ 33659:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "R": function() { return /* binding */ MDXRemote; }
});

// NAMESPACE OBJECT: ./node_modules/@mdx-js/react/index.js
var _mdx_js_react_namespaceObject = {};
__webpack_require__.r(_mdx_js_react_namespaceObject);
__webpack_require__.d(_mdx_js_react_namespaceObject, {
  "MDXContext": function() { return MDXContext; },
  "MDXProvider": function() { return MDXProvider; },
  "useMDXComponents": function() { return useMDXComponents; },
  "withMDXComponents": function() { return withMDXComponents; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-mdx-remote/dist/jsx-runtime.cjs
var jsx_runtime = __webpack_require__(32746);
;// CONCATENATED MODULE: ./node_modules/@mdx-js/react/lib/index.js
/**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('mdx/types.js').MDXComponents} Components
 *
 * @typedef Props
 *   Configuration.
 * @property {Components | MergeComponents | null | undefined} [components]
 *   Mapping of names for JSX components to React components.
 * @property {boolean | null | undefined} [disableParentContext=false]
 *   Turn off outer component context.
 * @property {ReactNode | null | undefined} [children]
 *   Children.
 *
 * @callback MergeComponents
 *   Custom merge function.
 * @param {Components} currentComponents
 *   Current components from the context.
 * @returns {Components}
 *   Merged components.
 */



/**
 * @type {import('react').Context<Components>}
 * @deprecated
 *   This export is marked as a legacy feature.
 *   That means it’s no longer recommended for use as it might be removed
 *   in a future major release.
 *
 *   Please use `useMDXComponents` to get context based components and
 *   `MDXProvider` to set context based components instead.
 */
const MDXContext = react.createContext({})

/**
 * @param {import('react').ComponentType<any>} Component
 * @deprecated
 *   This export is marked as a legacy feature.
 *   That means it’s no longer recommended for use as it might be removed
 *   in a future major release.
 *
 *   Please use `useMDXComponents` to get context based components instead.
 */
function withMDXComponents(Component) {
  return boundMDXComponent

  /**
   * @param {Record<string, unknown> & {components?: Components | null | undefined}} props
   * @returns {JSX.Element}
   */
  function boundMDXComponent(props) {
    const allComponents = useMDXComponents(props.components)
    return react.createElement(Component, {...props, allComponents})
  }
}

/**
 * Get current components from the MDX Context.
 *
 * @param {Components | MergeComponents | null | undefined} [components]
 *   Additional components to use or a function that takes the current
 *   components and filters/merges/changes them.
 * @returns {Components}
 *   Current components.
 */
function useMDXComponents(components) {
  const contextComponents = react.useContext(MDXContext)

  // Memoize to avoid unnecessary top-level context changes
  return react.useMemo(() => {
    // Custom merge via a function prop
    if (typeof components === 'function') {
      return components(contextComponents)
    }

    return {...contextComponents, ...components}
  }, [contextComponents, components])
}

/** @type {Components} */
const emptyObject = {}

/**
 * Provider for MDX context
 *
 * @param {Props} props
 * @returns {JSX.Element}
 */
function MDXProvider({components, children, disableParentContext}) {
  /** @type {Components} */
  let allComponents

  if (disableParentContext) {
    allComponents =
      typeof components === 'function'
        ? components({})
        : components || emptyObject
  } else {
    allComponents = useMDXComponents(components)
  }

  return react.createElement(
    MDXContext.Provider,
    {value: allComponents},
    children
  )
}

;// CONCATENATED MODULE: ./node_modules/@mdx-js/react/index.js


;// CONCATENATED MODULE: ./node_modules/next-mdx-remote/dist/index.js




if (typeof window !== 'undefined') {
  window.requestIdleCallback =
    window.requestIdleCallback ||
    function (cb) {
      var start = Date.now();
      return setTimeout(function () {
        cb({
          didTimeout: false,
          timeRemaining: function () {
            return Math.max(0, 50 - (Date.now() - start))
          },
        });
      }, 1)
    };

  window.cancelIdleCallback =
    window.cancelIdleCallback ||
    function (id) {
      clearTimeout(id);
    };
}

/**
 * Renders compiled source from next-mdx-remote/serialize.
 */
function MDXRemote({ compiledSource, frontmatter, scope, components = {}, lazy, }) {
    const [isReadyToRender, setIsReadyToRender] = (0,react.useState)(!lazy || typeof window === 'undefined');
    // if we're on the client side and `lazy` is set to true, we hydrate the
    // mdx content inside requestIdleCallback, allowing the page to get to
    // interactive quicker, but the mdx content to hydrate slower.
    (0,react.useEffect)(() => {
        if (lazy) {
            const handle = window.requestIdleCallback(() => {
                setIsReadyToRender(true);
            });
            return () => window.cancelIdleCallback(handle);
        }
    }, []);
    const Content = (0,react.useMemo)(() => {
        // if we're ready to render, we can assemble the component tree and let React do its thing
        // first we set up the scope which has to include the mdx custom
        // create element function as well as any components we're using
        const fullScope = Object.assign({ opts: { ..._mdx_js_react_namespaceObject, ...jsx_runtime/* jsxRuntime */.c } }, { frontmatter }, scope);
        const keys = Object.keys(fullScope);
        const values = Object.values(fullScope);
        // now we eval the source code using a function constructor
        // in order for this to work we need to have React, the mdx createElement,
        // and all our components in scope for the function, which is the case here
        // we pass the names (via keys) in as the function's args, and execute the
        // function with the actual values.
        const hydrateFn = Reflect.construct(Function, keys.concat(`${compiledSource}`));
        return hydrateFn.apply(hydrateFn, values).default;
    }, [scope, compiledSource]);
    if (!isReadyToRender) {
        // If we're not ready to render, return an empty div to preserve SSR'd markup
        return (react.createElement("div", { dangerouslySetInnerHTML: { __html: '' }, suppressHydrationWarning: true }));
    }
    // wrapping the content with MDXProvider will allow us to customize the standard
    // markdown components (such as "h1" or "a") with the "components" object
    const content = (react.createElement(MDXProvider, { components: components },
        react.createElement(Content, null)));
    // If lazy = true, we need to render a wrapping div to preserve the same markup structure that was SSR'd
    return lazy ? react.createElement("div", null, content) : content;
}




/***/ }),

/***/ 12569:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ renderMetaTags; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function renderMetaTags(data) {
    return data.map(({ tag, attributes, content }) => {
        let key = [tag];
        if (attributes && 'property' in attributes) {
            key.push(attributes.property);
        }
        if (attributes && 'name' in attributes) {
            key.push(attributes.name);
        }
        if (attributes && 'rel' in attributes) {
            key.push(attributes.rel);
        }
        if (attributes && 'sizes' in attributes) {
            key.push(attributes.sizes);
        }
        const Tag = tag;
        return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(Tag, Object.assign({ key: key.join('-') }, attributes), content));
    });
}
//# sourceMappingURL=renderMetaTags.js.map

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7536,6427,9909,8448,6119,3437,9774,2888,179], function() { return __webpack_exec__(24080); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);